import React, { useState } from "react";

import { triggerTrengo, useGetPracticeCrops, useTranslation } from "utils";

import { Link, StepsWidget } from "components";

interface FootprintingStepsProps {
  farmId: string;
  cropIds: string[];
  currentStep: number;
  year?: number;
  isLoading?: boolean;
}

export const FootprintingReviewSteps = ({ currentStep, year, isLoading, cropIds }: FootprintingStepsProps) => {
  const { t } = useTranslation("footprinting");
  const [trengo, setTrengo] = useState(false);
  const allCropsQuery = useGetPracticeCrops({ enabled: true });

  const steps = [
    {
      title: <span className="paragraph-m">{t("reviewAndSubmit.reviewFarm")}</span>,
    },
    ...cropIds.map((cropId) => ({
      title: (
        <span className="paragraph-m">
          {t("reviewAndSubmit.reviewCrop")} {allCropsQuery.data?.find((c) => c.id === cropId)?.name}
        </span>
      ),
    })),
    {
      title: <span className="paragraph-m">{t("reviewAndSubmit.submitForVerification")}</span>,
    },
  ];

  return (
    <StepsWidget
      className="review-and-submit-steps"
      subtitle={t("reviewAndSubmit.CO₂Footprint", { year })}
      title={t("reviewAndSubmit.title")}
      description={t("reviewAndSubmit.description")}
      steps={steps}
      currentStep={currentStep}
      direction="vertical"
      isLoading={isLoading || allCropsQuery.isLoading}
    >
      <span className="paragraph-m margin-0">
        {t("reviewAndSubmit.support")}
        <Link className="margin-left-25" onClick={() => triggerTrengo("email", trengo, setTrengo)}>
          {t("reviewAndSubmit.contact")}
        </Link>
      </span>
    </StepsWidget>
  );
};
